import { NumberParam, StringParam } from 'use-query-params'

import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import type { CompetitorsPhotoControlDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
import type { ColumnTitleSchema } from '@app/types/table'

export const columnTitleMap: ColumnTitleSchema<CompetitorsPhotoControlDataSource> = {
  count: 'Количество',
  productCode: 'Код товара'
}

export const tableSearchQuerySchema: TableSearchQuerySchema<CompetitorsPhotoControlDataSource> = {
  'table-count': NumberParam,
  'table-productCode': StringParam
} as const

export const columnsSearchSchema: ColumnTableSearchSchema<CompetitorsPhotoControlDataSource> = {
  count: { type: columnSearchSchemaOptionType.NUMERIC_INPUT },
  productCode: { type: columnSearchSchemaOptionType.INPUT }
}
